import img1 from "./images/xx99-mark-ii.png";
import img2 from "./images/xx99-mark-i.png";
import img3 from "./images/xx59.png";
import img4 from "./images/yx1.png";
import img5 from "./images/jbl-c100si.png";
import img6 from "./images/sony-wi-c200.png";
import img7 from "./images/zx9.png";
import img8 from "./images/zx7.png";

const data = [
  {
    id: "1",
    name: "xx99 mark ii",
    img: img1,
    desc: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Cum culpa tenetur eum voluptas aliquid deleniti doloremque repellendus modi minus exercitationem?",
    newProduct: true,
    category: "headphones",
    price: 2999,
    features: {
      p1: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Cum culpa tenetur eum voluptas aliquid deleniti doloremque repellendus modi minus exercitationem?",
      p2: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Cum culpa tenetur eum voluptas aliquid deleniti doloremque repellendus modi minus exercitationem?",
    },
    boxContent: [
      {
        item: "headphone unit",
        quantity: 1,
      },
      {
        item: "replacement earcups",
        quantity: 2,
      },
      {
        item: "user manuel",
        quantity: 1,
      },
      {
        item: "3.5mm 5m Audio Cable",
        quantity: 1,
      },
      {
        item: "travel bag",
        quantity: 1,
      },
    ],
  },
  {
    id: "2",
    name: "xx99 mark i",
    img: img2,
    desc: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Cum culpa tenetur eum voluptas aliquid deleniti doloremque repellendus modi minus exercitationem?",
    newProduct: false,
    category: "headphones",
    price: 2499,
    features: {
      p1: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Cum culpa tenetur eum voluptas aliquid deleniti doloremque repellendus modi minus exercitationem?",
      p2: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Cum culpa tenetur eum voluptas aliquid deleniti doloremque repellendus modi minus exercitationem?",
    },
    boxContent: [
      {
        item: "headphone unit",
        quantity: 1,
      },
      {
        item: "replacement earcups",
        quantity: 2,
      },
      {
        item: "user manuel",
        quantity: 1,
      },
      {
        item: "3.5mm 5m Audio Cable",
        quantity: 1,
      },
      {
        item: "travel bag",
        quantity: 1,
      },
    ],
  },
  {
    id: "3",
    name: "xx59",
    img: img3,
    desc: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Cum culpa tenetur eum voluptas aliquid deleniti doloremque repellendus modi minus exercitationem?",
    newProduct: false,
    category: "headphones",
    price: 1499,
    features: {
      p1: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Cum culpa tenetur eum voluptas aliquid deleniti doloremque repellendus modi minus exercitationem?",
      p2: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Cum culpa tenetur eum voluptas aliquid deleniti doloremque repellendus modi minus exercitationem?",
    },
    boxContent: [
      {
        item: "headphone unit",
        quantity: 1,
      },
      {
        item: "replacement earcups",
        quantity: 2,
      },
      {
        item: "user manuel",
        quantity: 1,
      },
      {
        item: "3.5mm 5m Audio Cable",
        quantity: 1,
      },
      {
        item: "travel bag",
        quantity: 1,
      },
    ],
  },
  {
    id: "4",
    name: "yx1",
    img: img4,
    desc: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Cum culpa tenetur eum voluptas aliquid deleniti doloremque repellendus modi minus exercitationem?",
    newProduct: false,
    category: "earphones",
    price: 799,
    features: {
      p1: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Cum culpa tenetur eum voluptas aliquid deleniti doloremque repellendus modi minus exercitationem?",
      p2: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Cum culpa tenetur eum voluptas aliquid deleniti doloremque repellendus modi minus exercitationem?",
    },
    boxContent: [
      {
        item: "earphone unit",
        quantity: 1,
      },
      {
        item: "replacement rubber tips",
        quantity: 2,
      },
      {
        item: "user manuel",
        quantity: 1,
      },
      {
        item: "charger",
        quantity: 1,
      },
      {
        item: "case",
        quantity: 1,
      },
    ],
  },
  {
    id: "5",
    name: "jbl c100si",
    img: img5,
    desc: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Cum culpa tenetur eum voluptas aliquid deleniti doloremque repellendus modi minus exercitationem?",
    newProduct: false,
    category: "earphones",
    price: 599,
    features: {
      p1: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Cum culpa tenetur eum voluptas aliquid deleniti doloremque repellendus modi minus exercitationem?",
      p2: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Cum culpa tenetur eum voluptas aliquid deleniti doloremque repellendus modi minus exercitationem?",
    },
    boxContent: [
      {
        item: "earphone unit",
        quantity: 1,
      },
      {
        item: "replacement rubber tips",
        quantity: 2,
      },
      {
        item: "user manuel",
        quantity: 1,
      },
      {
        item: "travel bag",
        quantity: 1,
      },
    ],
  },
  {
    id: "6",
    name: "sony wi-c200",
    img: img6,
    desc: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Cum culpa tenetur eum voluptas aliquid deleniti doloremque repellendus modi minus exercitationem?",
    newProduct: false,
    category: "earphones",
    price: 299,
    features: {
      p1: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Cum culpa tenetur eum voluptas aliquid deleniti doloremque repellendus modi minus exercitationem?",
      p2: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Cum culpa tenetur eum voluptas aliquid deleniti doloremque repellendus modi minus exercitationem?",
    },
    boxContent: [
      {
        item: "earphone unit",
        quantity: 1,
      },
      {
        item: "user manuel",
        quantity: 1,
      },
      {
        item: "3.5mm 5m Audio Cable",
        quantity: 1,
      },
    ],
  },
  {
    id: "7",
    name: "zx9",
    img: img7,
    desc: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Cum culpa tenetur eum voluptas aliquid deleniti doloremque repellendus modi minus exercitationem?",
    newProduct: false,
    category: "speakers",
    price: 5499,
    features: {
      p1: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Cum culpa tenetur eum voluptas aliquid deleniti doloremque repellendus modi minus exercitationem?",
      p2: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Cum culpa tenetur eum voluptas aliquid deleniti doloremque repellendus modi minus exercitationem?",
    },
    boxContent: [
      {
        item: "speaker unit",
        quantity: 1,
      },
      {
        item: "replacement rubber feet",
        quantity: 2,
      },
      {
        item: "user manuel",
        quantity: 1,
      },
      {
        item: "5mm 5m Audio Cable",
        quantity: 1,
      },
      {
        item: "case",
        quantity: 1,
      },
    ],
  },
  {
    id: "8",
    name: "zx7",
    img: img8,
    desc: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Cum culpa tenetur eum voluptas aliquid deleniti doloremque repellendus modi minus exercitationem?",
    newProduct: false,
    category: "speakers",
    price: 2299,
    features: {
      p1: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Cum culpa tenetur eum voluptas aliquid deleniti doloremque repellendus modi minus exercitationem?",
      p2: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Cum culpa tenetur eum voluptas aliquid deleniti doloremque repellendus modi minus exercitationem?",
    },
    boxContent: [
      {
        item: "speaker unit",
        quantity: 1,
      },
      {
        item: "user manuel",
        quantity: 1,
      },
      {
        item: "5mm 5m Audio Cable",
        quantity: 1,
      },
    ],
  },
];

export default data;
